import { Stack } from '@mui/material';
import { EditButton, ShowButton, useRecordContext } from 'react-admin';

import { Account } from '../types';

interface AccountAsideProps {
    link?: string;
}

export const AccountAside = ({ link = 'edit' }: AccountAsideProps) => {
    const record = useRecordContext<Account>();
    if (!record) return null;

    return (
        <Stack ml={4} width={250} minWidth={250} spacing={2}>
            {link === 'edit' ? (
                <EditButton label="Edit Account" />
            ) : (
                <ShowButton label="Show Account" />
            )}
        </Stack>
    );
};
